module.exports = __webpack_public_path__ + "media/images/countryrect/bb-436f41f7724bcf0ec5a9c1c0829c515b.svg";